<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row ----------------------------------- -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="fifth" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row ----------------------------------- -->


            <!-- >>> 'Overview' - Row -------------------------------------- -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px;">
                        <span class="index">
                            <i class="soap-icon-arrow-right circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>

                <!-- >>>  Left Side: : 'Overview' -->
                <form @submit.prevent="onSubmit">
                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">

                        <!-- >>> Booking Details -->
                        <div id="flight-features" class="tab-container">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs">
                                <li class="active">
                                    <a
                                        href="#flight-details"
                                        data-toggle="tab"
                                    >{{ tab_flightdetails[getCurrentLocale] }}</a>
                                </li>
                                <!-- <li><a href="#inflight-features" data-toggle="tab">{{ tab_inflightfeatures[getCurrentLocale] }}</a></li> -->
                            </ul>
                            <!-- <<< TabHeader:  -->

                            <!-- >>> Tab Content: -->
                            <div class="tab-content">
                                <!-- --------------------------------------- -->
                                <!-- >>> Tab: 'flight-details' -->
                                <div class="tab-pane fade in active" id="flight-details">
                                    <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->
                                    <sdr-flight-details flightdirection="outward" mode="normal" :datatocatch="getBookingCart" :modulo="modulo"></sdr-flight-details>
                                    <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Outward -->

                                    <!-- >>> 'Return Flight' Part -->
                                    <div v-if="getBookingFlightIdSelectedReturn !== null">
                                        <br />
                                        <hr />
                                        <br />
                                        <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                        <sdr-flight-details flightdirection="return" mode="normal" :datatocatch="getBookingCart" :modulo="modulo"></sdr-flight-details>
                                        <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Return -->
                                    </div>
                                    <!-- <<< 'Return Flight' Part -->

                                    <!-- >>> Total::Total::Total -->
                                    <br />
                                    <!-- <button type="button" class="btn-large full-width totalbutton sundair" v-bind:class="{ sundairsrvcs: modulo === 'services' }" style="cursor: initial; outline: none !important; outline-style: none !important;">
                                        -
                                        <br />
                                        <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                                    </button> -->

                                    <button
                                        type="button"
                                        class="btn-large full-width totalbutton sundair"
                                        v-bind:class="{ sundairsrvcs: modulo === 'services' }"
                                        style="cursor: initial; outline: none !important; outline-style: none !important;"
                                    >
                                        {{ Number(getBookingCartOutwardTotal) + Number(getBookingCartReturnTotal) | rndAmntRUAFWZ }}
                                        <br />
                                        <span style="font-size: 0.5em;">{{ tincludedtaxes[getCurrentLocale] }}</span>
                                    </button>

                                    <!-- <<< Total::Total::Total -->
                                </div>
                                <!-- <<< Tab: 'flight-details' -->
                                <!-- --------------------------------------- -->
                            </div>
                            <!-- <<< Tab Content: -->
                        </div>
                        <!-- <<< Booking Details -->

                        <br />
                        <!-- >>> Payment Details -->
                        <div class="booking-information sdr-box" v-if="modulo === 'booking'">
                            <h2>{{ payment[getCurrentLocale] }}:</h2>
                            <dl class="term-description">
                                <dt>{{ payment_firstname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.firstName }}</dd>
                                <dt>{{ payment_lastname[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.lastName }}</dd>
                                <dt>{{ payment_email[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.email }}</dd>
                                <dt>{{ payment_phone[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.phone }}</dd>
                                <dt>{{ payment_address[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.address }}</dd>
                                <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.zipCode }}</dd>
                                <dt>{{ payment_city[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.city }}</dd>
                                <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt>
                                <dd>{{ getBookingProcessBookingObject.customer.countryCode }}</dd>
                            </dl>
                            <hr />
                            <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                            <p>{{ forsecurity[getCurrentLocale] }}</p>
                            <br />
                            <p class="red-color" v-if="getBookingProcessBookingObject.payment.type !== 'OO'">
                                {{ paymentismadeby[getCurrentLocale] }}
                                {{ getBookingProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                                {{ getBookingProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}
                            .</p>
                        </div>

                        <div class="booking-information sdr-box" v-if="modulo === 'services' ">
                            <h2>{{ payment[getCurrentLocale] }}:</h2>
                            <dl class="term-description">
                                <dt>{{ payment_firstname[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.firstName }}</dd>
                                <dt>{{ payment_lastname[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.lastName }}</dd>
                                <dt>{{ payment_email[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.email }}</dd>
                                <dt>{{ payment_phone[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.phone }}</dd>
                                <dt>{{ payment_address[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.address }}</dd>
                                <dt>{{ payment_zipcode[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.zipCode }}</dd>
                                <dt>{{ payment_city[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.city }}</dd>
                                <dt>{{ payment_countrycode[getCurrentLocale] }}:</dt>
                                <dd>{{ getServicesProcessBookingObject.customer.countryCode }}</dd>
                            </dl>
                            <hr />
                            <h2>{{ paymentmethod[getCurrentLocale] }}:</h2>
                            <p>{{ forsecurity[getCurrentLocale] }}</p>
                            <br />
                            <p class="red-color" v-if="getServicesProcessBookingObject.payment.type !== 'OO'">
                                {{ paymentismadeby[getCurrentLocale] }}
                                {{ getServicesProcessBookingObject.payment.ccPayment !== undefined ? creditcard[getCurrentLocale] : null }}
                                {{ getServicesProcessBookingObject.payment.ddPayment !== undefined ? debit[getCurrentLocale] : null }}
                                {{ getServicesProcessBookingObject.payment.type === 'CS' ? cashpayment[getCurrentLocale] : null }}

                            .</p>
                        </div>
                        <!-- <<< Payment Details -->

                        <!-- >>> Confirm CheckBoxes -->

                        <!-- <<< Confirm CheckBoxes -->

                        <button type="submit" class="btn-large icon-check uppercase full-width"  v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }">{{ proceed[getCurrentLocale] }}</button>
                    </div>
                </form>
                <!-- <<<  Left Side: : 'Overview' -->



                <!-- >>>  Right Side: Sidebar, 'Overview' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Overview' -->
            </div>
            <!-- <<< 'Overview' - Row -------------------------------------- -->
        </div>




        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal
            name="size-modal2"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="200"
            :min-height="200"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            xwidth="40%"
            height="auto"
            @before-open="beforeOpen"
            @opened="opened"
            @closed="closed"
            @before-close="beforeClose">
            <div class="size-modal2-content">
                <h2>{{ webcomponenttype }}</h2>
                <span v-if="sections.length > 1">
                    <div
                        class="toggle-container box"
                        id="accordion1"
                        v-for="(section, index) in sections"
                        :key="index"
                        style="margin-bottom:0px;"
                    >
                        <div class="panel style1">
                            <h4 class="panel-title">
                                <a
                                    class="collapsed"
                                    v-bind:href="'#acc1_' + index"
                                    data-toggle="collapse"
                                    data-parent="#accordion1"
                                >{{ section.title }}</a>
                            </h4>
                            <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                <div class="panel-content">
                                    <span v-html="section.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>

                <span v-if="sections.length === 1">
                    <div class="panel style1">
                        <span v-html="sections[0].content"></span>
                    </div>
                </span>
            </div>
        </modal>



        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal
            name="wirecard-modal"
            transition="nice-modal-fade"
            classes="demo-modal-class"
            :min-width="1000"
            :min-height="550"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            height="auto"
            :clickToClose="false"
            @before-open="beforeOpenWirecardModal"
            @opened="openedWirecardModal"
            @closed="closedWirecardModal"
            @before-close="beforeCloseWirecardModal">
            <div class="size-modal2-content">
                <h2>3D Secure</h2>

                <iframe name="output_frame" id="output_frame" width="100%" height="550" :src='OutputFrameSrc'></iframe>

                <form name="downloadForm" id="downloadForm" ref="hiddenForm" :action="AcsUrl" method="POST" target="output_frame">
                    <input type="hidden" name="PaReq" :value="PaReq" />
                    <input type="hidden" name="TermUrl" :value="TermUrl" />
                    <input type="hidden" name="MD" value="" />
                </form>
            </div>
        </modal>
    </section>
</template>

<script>
    import { CONF_3DSECURE_ORIGIN }  from '../../../config.js';

    import FlightDetails from '../../booking/overview/FlightDetails.vue';
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import SharedCart from '../../shared/cart/Cart.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-flight-details': FlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-shared-cart': SharedCart,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_pcp: {
                    en: 'Dangerous goods',
                    de: 'Gefährliche Gegenstände',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                pleaseselectoverview: {
                    en: 'Step 5: Please check again your details.',
                    de: 'Schritt 5: Bitte überprüfen Sie noch einmal Ihre Angaben.'
                },
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückflug'
                },
                tab_flightdetails: {
                    en: 'Your booking overview',
                    de: 'Ihre Buchungsübersicht'
                },
                tab_inflightfeatures: {
                    en: 'Inflight Features',
                    de: 'Funktionen an Bord'
                },
                tab_baggage: {
                    en: 'Baggage',
                    de: 'Gepäck'
                },
                tab_farerules: {
                    en: 'Fare Rules',
                    de: 'Tarifbestimmungen'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                tab_header_flightdetails: {
                    en: 'Your flight and booking details for the outbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
                },
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for the inbound flight',
                    de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
                },
                tab_header_inflightfeatures: {
                    en: 'For your well-being on board',
                    de: 'Für Ihr Wohlbefinden an Bord'
                },
                tab_header_farerulesforyourflight: {
                    en: 'Fare Rules for your Flight',
                    de: 'Tarifregeln für Ihren Flug'
                },
                // >>> --------------------------
                adult: {
                    en: 'Adult',
                    de: 'Erwachsener',
                },
                child: {
                    en: 'Child',
                    de: 'Kind',
                },
                infant: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Cancellation',
                    de: 'Stornierung',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                seatsandbaggage: {
                    en: 'Seats & Baggage',
                    de: 'Sitze & Gepäck',
                },
                extracharge: {
                    en: 'Extra Charge',
                    de: 'Aufpreis'
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                // >>> --------------------------
                mr: {
                    en: 'Mr',
                    de: 'Herr',
                },
                mrs: {
                    en: 'Mrs',
                    de: 'Frau',
                },
                chd: {
                    en: 'Child',
                    de: 'Kind',
                },
                inf: {
                    en: 'Infant',
                    de: 'Kleinkind',
                },
                // >>> --------------------------
                born: {
                    en: 'Born',
                    de: 'Geb. am',
                },
                // >>> --------------------------
                form_confirmabb_1 : {
                    en: 'By continuing, you agree to the Terms and Conditions.',
                    de: 'Ich habe die ABBs gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmagb_1 : {
                    en: 'I confirm that I am 18 years or older and I have read and agree to the General Terms.',
                    de: 'Ich bestätige, dass ich 18 Jahre oder älter bin und ich habe die AGB gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmdangerous_1 : {
                    en: 'I have read the information on the carriage of dangerous goods and agree to it.',
                    de: 'Ich habe die Informationen zur Beförderung gefährlicher Gegenstände gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmprivacy_1 : {
                    en: 'I have read the privacy policy and agree to it.',
                    de: 'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden.',
                },
                form_confirmadditional_1 : {
                    en: 'I have noted the charges for additional services and agree to it.',
                    de: 'Ich habe die Entgelte für Zusatzleistungen zur Kenntnis genommen und erkläre mich damit einverstanden.',
                },
                pleaseclickallcheckboxes : {
                    en: 'Please confirm all Checkboxes.',
                    de: 'Bitte bestätigen sie alle Checkboxen.',
                },
                // >>> --------------------------
                travelerinformation: {
                    en: 'Traveler Information',
                    de: 'Reisende Infos',
                },
                payment: {
                    en: 'Your Payment details',
                    de: 'Ihre Zahlungsdetails',
                },
                paymentmethod : {
                    en: 'Your Payment method',
                    de: 'Ihre Zahlungsmethode',
                },
                forsecurity: {
                    en: 'For security reasons we do not write out your complete payment data here.',
                    de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.',
                },
                paymentismadeby : {
                    en: 'Payment is made by ',
                    de: 'Die Zahlung erfolgt durch ',
                },
                creditcard: {
                    en: 'Creditcard',
                    de: 'Kreditkarte',
                },
                debit: {
                    en: 'Direct Debit',
                    de: 'Überweisung',
                },
                cashpayment: {
                    en: 'Cash',
                    de: 'Barzahlung',
                },
                payment_firstname: {
                    en: 'FIRST NAME',
                    de: 'Vorname',
                },
                payment_lastname: {
                    en: 'LAST NAME',
                    de: 'Nachname',
                },
                payment_email: {
                    en: 'EMAIL ADDRESS',
                    de: 'E-Mail',
                },
                payment_phone: {
                    en: 'Phone',
                    de: 'Telefon',
                },
                payment_address: {
                    en: 'STREET ADDRESS AND NUMBER',
                    de: 'Adresse',
                },
                payment_zipcode: {
                    en: 'ZIP CODE',
                    de: 'PLZ',
                },
                payment_city: {
                    en: 'TOWN / CITY',
                    de: 'Wohnort',
                },
                payment_countrycode: {
                    en: 'COUNTRY',
                    de: 'Land',
                },
                // >>> --------------------------
                pleaseconfirm: {
                    en: 'Please confirm',
                    de: 'Bitte bestätigen Sie',
                },
                flightprice : {
                    en: 'Flight price',
                    de: 'Flugpreis',
                },
                tincludedtaxes: {
                    en: 'incl. Taxes, Fees & Surcharges',
                    de: 'inkl. Steuern, Gebühren & Zuschlägen',
                },
                total : {
                    en: 'Total',
                    de: 'Gesamt',
                },
                totaloutwardprice: {
                    en: 'Total Outward',
                    de: 'Gesamt Hinflug',
                },
                totalreturnprice: {
                    en: 'Total Return',
                    de: 'Gesamt Rückflug',
                },
                // >>> --------------------------
                inflightfeatures_wifi: {
                    en: 'WI_FI',
                    de: 'WI_FI',
                },
                inflightfeatures_entertainment: {
                    en: 'Entertainment',
                    de: 'Entertainment',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_television: {
                    en: 'Television',
                    de: 'Fernsehen',
                },
                inflightfeatures_airconditioning: {
                    en: 'Air conditioning',
                    de: 'Klimatisierung',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_drink: {
                    en: 'Drink',
                    de: 'Getränke',
                },
                inflightfeatures_games: {
                    en: 'Games',
                    de: 'Spiele',
                },
                inflightfeatures_coffee: {
                    en: 'coffee',
                    de: 'Kaffee',
                },
                inflightfeatures_wines: {
                    en: 'Wines',
                    de: 'Weine',
                },
                inflightfeatures_shopping: {
                    en: 'Shopping',
                    de: 'Shopping',
                },
                inflightfeatures_food: {
                    en: 'Food',
                    de: 'Essen',
                },
                inflightfeatures_comfort: {
                    en: 'Comfort',
                    de: 'Komfort',
                },
                inflightfeatures_magazines: {
                    en: 'Magazines',
                    de: 'Zeitschriften',
                },
                agencycommision: {
                    en: 'Your agency commision is: ',
                    de: 'Ihre Agentur-Provision ist: ',
                },
                // >>> --------------------------
                inthissection: {
                    en: "In this section you'll find information on baggage allowances, special equipment and sports items as well as restricted items. We've also included some tips to make your trip more enjoyable.",
                    de: 'In diesem Abschnitt finden Sie Informationen über Freigepäck, Sonderausstattungen und Sportartikel sowie eingeschränkte Gegenstände. Wir haben auch einige Tipps beigefügt, um Ihre Reise noch angenehmer zu gestalten.',
                },
                // >>> --------------------------
                proceed: {
                    en: 'BOOK WITH OBLIGATION TO PAY',
                    de: 'ZAHLUNGSPFLICHTIG BUCHEN',
                },
                threedsecurecancelled: {
                    en: '3D Secure Proceedure canceled.',
                    de: '3D Secure Vorgang abgebrochen.',
                },
                // >>> -------------------------- Modal WireCard
                AcsUrl: null,
                PaReq: null,
                TermUrl: null,
                OutputFrameSrc: null,

                // >>> -------------------------- Modal

                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
                // >>> --------------------------
                checkedBoxes: [],
                // >>> --------------------------
                bankaccount_holder: null,
                bankaccount_no: null,
                bankaccount_bankno: null,
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                // >>> --------------------------
                'getFlagBookingOverviewIsReadyForProcess',
                'getBookingProcessBookingObject',
                'getBookingFlightIdSelectedReturn', // got RET Flight?
                'getBookingFlightIdSelectedOutward',
                'getBookingUsersSearchData',
                'getBookingCart', // Pax per Pax
                'getBookingCartOutwardTotal', // Summed up Outward ALL
                'getBookingCartReturnTotal', // Summed up Return ALL
                // >>> --------------------------
                'getServicesProcessBookingObject', // object fpr process booking
                'getFlagSharedAgencyLoggedIn', // Agency
                'getSharedAgencyLoginResultsAmountAndValue', // Agency (Parts)
                // >>> --------------------------
                'getBookingWireCardEnrollPaymentResults',
                'getServicesValidatePassengersObject'
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowbookingsconfirmation' ('Call(s) done ...').
        * Note: Catch Event 'messsage' from iFrame here too.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> booking/overview/Overview.vue >>> created');
            eventBus.$on('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
            eventBus.$on('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
            // >>> Listener for iFrame ------------------------------
            window.addEventListener("message", me.onEmit_MessageFromIFrameWasPosted);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function () {

            let me = this;


            me.$toc('>>> booking/overview/Overview.vue >>> mounted');


        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> booking/overview/Overview.vue >>> beforeDestroy');
            window.removeEventListener("message", me.onEmit_MessageFromIFrameWasPosted);
            eventBus.$off('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
            eventBus.$off('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagBookingOverviewIsReadyForProcess',
                'actn_setServicesProcessBookingResults',
                'actn_call_processBooking',
                'actn_call_processDirectBooking',
                'actn_call_registrationNewSpecials',
                'actn_call_wireCardEnrollPayment', // new: wirecard enrollment
            ]),


            /******************************************************************* 'ServiceCalls - Shared'
            * ServiceCalls: 'Shared'
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            * ToDo: Get it into Booking Shared Store.
            *
            * @param {string} comptype (kind of Component)
            * @param
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> booking/overview/Overview.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };

                // >>> #267, Translation ---------------------------------------
                if (comptype === 'ABB') {
                    this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
                }  else if (comptype === 'AGB') {
                    this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
                }  else if (comptype === 'PCP') {
                    this.webcomponenttype = this.listpoint_pcp[this.getCurrentLocale];
                }  else if (comptype === 'PCPE') {
                    this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                 me.$modal.show('size-modal2', { data: response.data });

                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Overview Form' gets (not really) submitted.
            * Desc: Decides how to go on from here. Enrollment or Process.
            * Note: CreditCard - YES   => 'wirecard enroll payment'. (@first)
            * Note: CreditCard - NO    => 'normal process payment'.
            *
            * @param {Object} submitEvent (Event)
            */
            onSubmit: function(submitEvent) {

                let me = this;


                me.$toc('>>> booking/overview/Overview.vue >>> onSubmit');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    // >>> Call(s) - Enrollment or Process? ---------
                    if (this.getBookingProcessBookingObject.payment.ccPayment !== undefined) { // creditcard yes    => enrollment
                        this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment());
                    }
                    if (this.getBookingProcessBookingObject.payment.ccPayment === undefined) { // creditcard no     => process
                        // this.actn_call_processBooking(this.createObjectForProcessNotCreditCard());
                        this.actn_call_processDirectBooking(this.createObjectForProcessNotCreditCard()); // Direct
                    }
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    // >>> Call(s) - Enrollment or Process? ---------
                    if (this.getServicesProcessBookingObject.payment.ccPayment !== undefined) { // creditcard yes    => enrollment
                        this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment());
                    }
                    if (this.getServicesProcessBookingObject.payment.ccPayment === undefined) { // creditcard no     => process
                        this.actn_call_registrationNewSpecials(this.createObjectForProcessNotCreditCard());
                    }
                }

            }, // eof onSubmit()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowConfirmation()
            *
            * Desc: Handle 'processBooking': Reaction (push 'Confirmation').
            * Note: Handle 'registrationNewSpecials': Reaction (push 'Confirmation').
            *
            */
            onEmit_ReadyToShowConfirmation: function() {

                let me = this,
                    options = {};


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowConfirmation');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                setTimeout(function(){
                    me.$vp_um();
                    me.$vp_um();
                    me.$router.push({ path: '/confirmation/' + me.modulo });
                }, 500);

                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 600);

            }, // eo function onEmit_ReadyToShowConfirmation()


            /*******************************************************************
            * onEmit_ReadyToShowWireCardModal()
            *
            * Desc: New CC Payment Way. WireCard. Enrollment.
            * Note: New Payment via Heidelpay.
            *
            */
            onEmit_ReadyToShowWireCardModal: function() {

                let me = this;


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowWireCardModal');
                me.$modal.show('wirecard-modal', { });

                if (this.getBookingWireCardEnrollPaymentResults.provider === "heidelpay") {
                    // gets set in: 'beforeOpenWirecardModal'
                    // this.$refs.outputFrame.src = this.getBookingWireCardEnrollPaymentResults.redirectUrl;
                }

                if (this.getBookingWireCardEnrollPaymentResults.provider === "wirecard") {
                    // submit
                    setTimeout(function() {
                        this.$refs.hiddenForm.submit();
                    }.bind(this), 500);
                }

            }, // eo function onEmit_ReadyToShowWireCardModal()



            /*******************************************************************
            * onEmit_MessageFromIFrameWasPosted()
            *
            * Desc: Handler for Event:postMessage (from iFrame).
            * Note:
            * Note: https://test-booking2019-2.sundair.com
            *
            * @param {Object} event (Event)
            */
            onEmit_MessageFromIFrameWasPosted: function(event) {

                let me = this;


                me.$toc('>>> booking/overview/Overview.vue >>> onEmit_MessageFromIFrameWasPosted');
                me.$modal.hide('wirecard-modal', {});

                if (this.modulo === 'booking') {
                    if (event.data.status === 'OK' && event.origin === CONF_3DSECURE_ORIGIN) {
                        // this.actn_call_processBooking(this.createObjectForProcessCreditCard(event)); // Before
                        this.actn_call_processDirectBooking(this.createObjectForProcessCreditCard(event)); // Direct
                    }
                    if (event.data.status === 'KO' && event.origin === CONF_3DSECURE_ORIGIN) {
                        if (event.data.statusReason !== null && event.data.statusReason.length > 0) {
                            me.$toasted.global.sdr_app_error({
                                message: event.data.statusReason[0].description
                            });
                        }
                        if (event.data.statusReason === null || event.data.statusReason.length === 0) {
                            me.$toasted.global.sdr_app_error({
                                message: this.threedsecurecancelled[this.getCurrentLocale]
                            });
                        }
                    }
                }

                if (this.modulo === 'services') {
                    if (event.data.status === 'OK' && event.origin === CONF_3DSECURE_ORIGIN) {
                        this.actn_call_registrationNewSpecials(this.createObjectForProcessCreditCard(event));
                    }
                    if (event.data.status === 'KO' && event.origin === CONF_3DSECURE_ORIGIN) {
                        if (event.data.statusReason !== null && event.data.statusReason.length > 0) {
                            me.$toasted.global.sdr_app_error({
                                message: event.data.statusReason[0].description
                            });
                        }
                        if (event.data.statusReason === null || event.data.statusReason.length === 0) {
                            me.$toasted.global.sdr_app_error({
                                message: this.threedsecurecancelled[this.getCurrentLocale]
                            });
                        }
                    }
                }

            }, // eo function onEmit_MessageFromIFrameWasPosted()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * createObjectForEnrollment()
            *
            * Desc: Build Payload Object for Enrollment Call.
            * Note: Both: 'Booking', 'Services'.
            *
            * @return {Object}
            */
            createObjectForEnrollment: function (){

                var me = this,
                    myOverviewParams = {};


                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForEnrollment');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = {...this.getBookingProcessBookingObject };

                    delete myOverviewParams.bookingKeyCode;
                    delete myOverviewParams.isReservation;
                    delete myOverviewParams.passengers;
                    delete myOverviewParams.voucherCodes;

                    myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                    myOverviewParams.comment = null;
                    myOverviewParams.currency = 'EUR';
                    myOverviewParams.directBooking = true; // #96

                    myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                    myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                    myOverviewParams.payment.comments = null;
                    myOverviewParams.payment.currencyCode = null;
                    myOverviewParams.payment.ddPayment = null;
                    myOverviewParams.payment.ndPayment = null;
                    myOverviewParams.payment.refererIP = '129.12.12.12';

                    if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                    }
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = { ...this.getServicesProcessBookingObject };

                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }

                    delete myOverviewParams.bookingKeyCode;
                    delete myOverviewParams.isReservation;
                    delete myOverviewParams.passengers;
                    delete myOverviewParams.voucherCodes;

                    myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                    myOverviewParams.comment = null;
                    myOverviewParams.currency = 'EUR';
                    myOverviewParams.directBooking = true; // #96

                    myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                    myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                    myOverviewParams.payment.comments = null;
                    myOverviewParams.payment.currencyCode = null;
                    myOverviewParams.payment.ddPayment = null;
                    myOverviewParams.payment.ndPayment = null;
                    myOverviewParams.payment.refererIP = '129.12.12.12';

                    if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                    }
                    if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                        myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                    }
                }


                return myOverviewParams;

            }, // eo function createObjectForEnrollment()


            /*******************************************************************
            * syncInfantServicePricesFromCart()
            *
            * Desc: Set infantServices[].price from cart (Ownprices user input).
            * Note: Same source as overview display — not the amntInf from flight search.
            *
            * @param {Array} passengers
            */
            syncInfantServicePricesFromCart: function(passengers) {

                let me = this,
                    countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                    countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                    countADTCHD = countADT + countCHD;


                passengers.forEach(function (pax) {

                    let infantCart = null,
                        leg = null;


                    if (!pax.infantServices || pax.infantServices.length === 0) {
                        return;
                    }

                    infantCart = me.getBookingCart.find(function (cartPax) {
                        return parseFloat(cartPax.id_pax, 10) === parseFloat(pax.id_pax, 10) + countADTCHD && cartPax.type === 'INF';
                    });

                    if (infantCart === undefined) {
                        return;
                    }

                    pax.infantServices.forEach(function (infSvc) {
                        leg = null;

                        if (infSvc.idFlight === me.getBookingFlightIdSelectedOutward) {
                            leg = infantCart.outward;
                        }
                        if (infSvc.idFlight === me.getBookingFlightIdSelectedReturn) {
                            leg = infantCart.return;
                        }

                        if (leg !== null && leg !== undefined) {
                            if (leg.price === null || leg.price === undefined || leg.price === '') {
                                infSvc.price = null;
                            } else {
                                infSvc.price = +leg.price;
                            }
                        }
                    });

                });

            }, // eo function syncInfantServicePricesFromCart()


            /*******************************************************************
            * createObjectForProcessNotCreditCard()
            *
            * Desc: Build Payload Object for Process Call. NOT CC!
            * Note: Both: 'Booking', 'Services'.
            *
            * @return {Object}
            */
            createObjectForProcessNotCreditCard: function (){

                var me = this,
                    myOverviewParams = {},
                    directPrice = [];



                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessNotCreditCard');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = {...this.getBookingProcessBookingObject };

                    // >>> -------------------------------- New Direct additions ...
                    myOverviewParams.passengers.forEach((pax, i) => {
                        const found = this.getBookingCart.find(element => element.id_pax === pax.id_pax);

                        if (found !== undefined) {
                            directPrice.push(
                                {
                                    "direction":"OUTBOUND",
                                    "nettoPrice":+found.outward.price,
                                    "tax":{
                                        "airportTax":+found.outward.taxes.air,
                                        "aviationTax":+found.outward.taxes.avia,
                                        "fuelTax":+found.outward.taxes.fuel,
                                        "securityTax":+found.outward.taxes.sec,
                                        "servicetax":+found.outward.taxes.srvc,
                                        "transactionFee":0
                                    }
                                },
                            );

                            if (this.getBookingFlightIdSelectedReturn !== null) {
                                directPrice.push(
                                    {
                                        "direction":"INBOUND",
                                        "nettoPrice":+found.return.price,
                                        "tax":{
                                            "airportTax":+found.return.taxes.air,
                                            "aviationTax":+found.return.taxes.avia,
                                            "fuelTax":+found.return.taxes.fuel,
                                            "securityTax":+found.return.taxes.sec,
                                            "servicetax":+found.return.taxes.srvc,
                                            "transactionFee":0
                                        }
                                    },
                                );
                            }


                            pax.directPrice = directPrice;
                            directPrice = [];
                        }
                    });

                    this.syncInfantServicePricesFromCart(myOverviewParams.passengers);
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = { ...this.getServicesProcessBookingObject };




                    let deepClone = JSON.parse(JSON.stringify(this.getServicesValidatePassengersObject.passengers)); // again catch from validate object Bec. it can still get deleted in cart here
                    myOverviewParams.passengers = deepClone; // catch (validated) pax & srvcs


                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }
                }


                return myOverviewParams;

            }, // eo function createObjectForProcessNotCreditCard()


            /*******************************************************************
            * createObjectForProcess()
            *
            * Desc: Build Payload Object for Process Call. CC ONLY!
            * Note: Both: 'Booking', 'Services'.
            *
            * @param {Object} event (Event)
            * @return {Object}
            */
            createObjectForProcessCreditCard: function (event){

                var me = this,
                    myOverviewParams = {},
                    directPrice = [];


                me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessCreditCard');
                // >>> 'Booking' ------------------------------------
                if (this.modulo === 'booking') {
                    myOverviewParams = {...this.getBookingProcessBookingObject };

                    delete myOverviewParams.payment.ccPayment.cc_brand;
                    delete myOverviewParams.payment.ccPayment.cc_cvc;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                    delete myOverviewParams.payment.ccPayment.cc_holder;
                    delete myOverviewParams.payment.ccPayment.cc_number;
                    delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                    delete myOverviewParams.payment.ccPayment.refererIp;

                    myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;

                    // >>> -------------------------------- New Direct additions ...
                    myOverviewParams.passengers.forEach((pax, i) => {
                        const found = this.getBookingCart.find(element => element.id_pax === pax.id_pax);

                        if (found !== undefined) {
                            directPrice.push(
                                {
                                    "direction":"OUTBOUND",
                                    "nettoPrice":+found.outward.price,
                                    "tax":{
                                        "airportTax":+found.outward.taxes.air,
                                        "aviationTax":+found.outward.taxes.avia,
                                        "fuelTax":+found.outward.taxes.fuel,
                                        "securityTax":+found.outward.taxes.sec,
                                        "servicetax":+found.outward.taxes.srvc,
                                        "transactionFee":0
                                    }
                                },
                            );

                            if (this.getBookingFlightIdSelectedReturn !== null) {
                                directPrice.push(
                                    {
                                        "direction":"INBOUND",
                                        "nettoPrice":+found.return.price,
                                        "tax":{
                                            "airportTax":+found.return.taxes.air,
                                            "aviationTax":+found.return.taxes.avia,
                                            "fuelTax":+found.return.taxes.fuel,
                                            "securityTax":+found.return.taxes.sec,
                                            "servicetax":+found.return.taxes.srvc,
                                            "transactionFee":0
                                        }
                                    },
                                );
                            }


                            pax.directPrice = directPrice;
                            directPrice = [];
                        }
                    });

                    this.syncInfantServicePricesFromCart(myOverviewParams.passengers);
                }


                // >>> 'Services' -----------------------------------
                if (this.modulo === 'services') {
                    myOverviewParams = {...this.getServicesProcessBookingObject };

                    console.log('myOverviewParams')
                    console.log(myOverviewParams)



                    // >>> Edit Object ------------------------------
                    for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                        delete myOverviewParams.passengers[i].id_pax;
                    }

                    delete myOverviewParams.payment.ccPayment.cc_brand;
                    delete myOverviewParams.payment.ccPayment.cc_cvc;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                    delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                    delete myOverviewParams.payment.ccPayment.cc_holder;
                    delete myOverviewParams.payment.ccPayment.cc_number;
                    delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                    delete myOverviewParams.payment.ccPayment.refererIp;

                    myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;

                }


                return myOverviewParams;

            }, // eo function createObjectForProcessCreditCard()



            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen: function(event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()


            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc: Empty Sections again.
            * Note:
            *
            */
            beforeClose: function() {

                this.sections = [];

            }, // eof beforeClose()


            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc: Catch up Params.
            * Note:
            *
            */
            beforeOpenWirecardModal: function(event) {

                if (this.getBookingWireCardEnrollPaymentResults.provider === "heidelpay") {
                    this.OutputFrameSrc = this.getBookingWireCardEnrollPaymentResults.redirectUrl;
                }

                if (this.getBookingWireCardEnrollPaymentResults.provider === "wirecard") {
                    this.AcsUrl = this.getBookingWireCardEnrollPaymentResults.threeD.acsUrl;
                    this.PaReq = this.getBookingWireCardEnrollPaymentResults.threeD.pareq;
                    this.TermUrl = this.getBookingWireCardEnrollPaymentResults.termUrl;
                }

            }, // eof beforeOpenWirecardModal()


            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeCloseWirecardModal: function() {

            }, // eof beforeCloseWirecardModal()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active,
    #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    /* Modal */
    .size-modal2-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal='size-modal2'] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #f7f7f7;
        box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }



    /* a {
            color: rgb(119, 41, 85);
        } */

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>
